import React from 'react'

// shared components
import PersonCard from 'components/shared/PersonCard'
import AdultStatus from 'components/shared/AdultStatus'

// local components
import EditButton from './EditButton'
import RemoveButton from './RemoveButton'
import DeleteParentModal from './DeleteParentModal'

export default function ParentCard(props) {
  const { parent, setModal, reupRequired, editable } = props
  const adultType = parent.primaryAccountHolder ? 'Account Holder' : null
  const relationship = parent.relationshipToCampers

  return (
    <PersonCard
      header={
        <AdultStatus
          adult={parent}
          type={adultType}
          relationship={relationship}
          reupRequired={reupRequired}
        />
      }
      desktopButtons={
        editable ? (
          <>
            <EditButton
              align='right'
              parent={parent}
              reupRequired={reupRequired}
            />
            <RemoveButton align='right' parent={parent} setModal={setModal} />
          </>
        ) : null
      }
      mobileButtons={
        editable ? (
          <>
            <EditButton parent={parent} reupRequired={reupRequired} />
            <RemoveButton parent={parent} setModal={setModal} />
          </>
        ) : null
      }
    >
      <DeleteParentModal parent={parent} />
    </PersonCard>
  )
}
